__webpack_require__.p = "/widget/size-guide/";